<app-base-animals-button
    [loading]="loading"
    [title]="'Animals'"
    [url]="'/main/animals'"
    [unknown]="unknown"
    [cows]="cows"
    [bulls]="bulls"
    [calves]="calves"
    [steers]="steers"/>
